import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * SignatureField Component (shared)
 *
 * Canvas-based signature input using react-signature-canvas.
 * Reusable across miniapps. Based on former/DrawField but simplified for signature-only use.
 */
import React, { useRef, useEffect, useState, useCallback } from 'react';
import SignatureCanvas from 'react-signature-canvas';
var MAX_BASE64_LENGTH = 60000;
var MIN_CANVAS_WIDTH = 280;
var CANVAS_HEIGHT = 200;
export function SignatureField({ value, onChange, disabled, clearLabel, warningLabel, }) {
    var canvasRef = useRef(null);
    var containerRef = useRef(null);
    var [sizeWarning, setSizeWarning] = useState(false);
    var [canvasWidth, setCanvasWidth] = useState(null);
    var checkAndEmit = function (data) {
        if (data.length > MAX_BASE64_LENGTH) {
            setSizeWarning(true);
            return;
        }
        setSizeWarning(false);
        onChange(data);
    };
    var measureWidth = useCallback(function () {
        if (containerRef.current) {
            var w = containerRef.current.clientWidth;
            if (w > 0) {
                setCanvasWidth(Math.max(w, MIN_CANVAS_WIDTH));
            }
        }
    }, []);
    useEffect(function () {
        measureWidth();
        var el = containerRef.current;
        if (!el)
            return;
        var ro = new ResizeObserver(function () { measureWidth(); });
        ro.observe(el);
        return function () { ro.disconnect(); };
    }, [measureWidth]);
    // Load saved value after canvas is sized
    useEffect(function () {
        if (!value || !canvasWidth || !canvasRef.current)
            return;
        canvasRef.current.fromDataURL(value, {
            width: canvasWidth,
            height: CANVAS_HEIGHT,
            ratio: 1,
        });
    }, [canvasWidth]);
    var handleEnd = function () {
        if (canvasRef.current) {
            var data = canvasRef.current.toDataURL('image/png');
            checkAndEmit(data);
        }
    };
    var handleClear = function () {
        if (canvasRef.current) {
            canvasRef.current.clear();
        }
        setSizeWarning(false);
        onChange('');
    };
    // Wait for measurement
    if (canvasWidth === null) {
        return (_jsx("div", { className: "signature-field", ref: containerRef, style: { minHeight: CANVAS_HEIGHT } }));
    }
    return (_jsxs("div", { className: "signature-field", ref: containerRef, children: [_jsx("div", { className: "signature-field-canvas-wrapper", children: _jsx(SignatureCanvas, { ref: canvasRef, onEnd: handleEnd, penColor: "black", minWidth: 0.5, maxWidth: 2.5, canvasProps: {
                        className: 'signature-field-canvas',
                        width: canvasWidth,
                        height: CANVAS_HEIGHT,
                    } }) }), sizeWarning && (_jsx("div", { className: "signature-field-warning", children: warningLabel || 'A rajz tul osszetett, egyszerusitsd vagy torold es rajzold ujra.' })), _jsx("div", { className: "signature-field-controls", children: _jsxs("button", { type: "button", onClick: handleClear, className: "signature-field-clear", disabled: disabled, children: [_jsx("i", { className: "fa fa-eraser" }), clearLabel || 'Torles'] }) })] }));
}
